// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug {
  display: none;
}

.load {
  display: block;
  margin: 0 auto;
}

h2 {
  margin: 0;
  margin-left: 6px;
  font-size: 14px;
}

h3 {
  text-align: center;
}

h4 {
  text-align: center;
}

table {
  width: 75%;
  max-width: 900px;
  margin: 0 auto;
  font-family: consolas, monospace;
  border-collapse: collapse;
}
table thead th {
  text-align: left;
  width: 33.3%;
}
table tbody tr {
  border-top: 1px solid #eee;
}

/* (mdc-migration): The following rule targets internal classes of slider that may no longer apply for the MDC version. */
input[type=range],
mat-slider {
  width: 100%;
  max-width: 600px;
  display: block;
  margin: 0 auto;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZlaGljbGUtdmVyc2lvbi5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7QUFDRjs7QUFFQTtFQUNFLGNBQUE7RUFDQSxjQUFBO0FBQ0Y7O0FBRUE7RUFDRSxTQUFBO0VBQ0EsZ0JBQUE7RUFDQSxlQUFBO0FBQ0Y7O0FBRUE7RUFDRSxrQkFBQTtBQUNGOztBQUNBO0VBQ0Usa0JBQUE7QUFFRjs7QUFDQTtFQUNFLFVBQUE7RUFDQSxnQkFBQTtFQUNBLGNBQUE7RUFDQSxnQ0FBQTtFQUNBLHlCQUFBO0FBRUY7QUFBRTtFQUNFLGdCQUFBO0VBQ0EsWUFBQTtBQUVKO0FBQ0U7RUFDRSwwQkFBQTtBQUNKOztBQUdBLHlIQUFBO0FBQ0E7O0VBRUUsV0FBQTtFQUNBLGdCQUFBO0VBQ0EsY0FBQTtFQUNBLGNBQUE7QUFBRiIsImZpbGUiOiJ2ZWhpY2xlLXZlcnNpb24uY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZGVidWcge1xuICBkaXNwbGF5OiBub25lO1xufVxuXG4ubG9hZCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXJnaW46IDAgYXV0bztcbn1cblxuaDIge1xuICBtYXJnaW46IDA7XG4gIG1hcmdpbi1sZWZ0OiA2cHg7XG4gIGZvbnQtc2l6ZTogMTRweDtcbn1cblxuaDMge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5oNCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxudGFibGUge1xuICB3aWR0aDogNzUlO1xuICBtYXgtd2lkdGg6IDkwMHB4O1xuICBtYXJnaW46IDAgYXV0bztcbiAgZm9udC1mYW1pbHk6IGNvbnNvbGFzLCBtb25vc3BhY2U7XG4gIGJvcmRlci1jb2xsYXBzZTogY29sbGFwc2U7XG5cbiAgdGhlYWQgdGgge1xuICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gICAgd2lkdGg6IDMzLjMlO1xuICB9XG5cbiAgdGJvZHkgdHIge1xuICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCAjZWVlO1xuICB9XG59XG5cbi8qIChtZGMtbWlncmF0aW9uKTogVGhlIGZvbGxvd2luZyBydWxlIHRhcmdldHMgaW50ZXJuYWwgY2xhc3NlcyBvZiBzbGlkZXIgdGhhdCBtYXkgbm8gbG9uZ2VyIGFwcGx5IGZvciB0aGUgTURDIHZlcnNpb24uICovXG5pbnB1dFt0eXBlPVwicmFuZ2VcIl0sXG5tYXQtc2xpZGVyIHtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC13aWR0aDogNjAwcHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXJnaW46IDAgYXV0bztcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/vehicle-version/vehicle-version.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,yBAAA;AAEF;AAAE;EACE,gBAAA;EACA,YAAA;AAEJ;AACE;EACE,0BAAA;AACJ;;AAGA,yHAAA;AACA;;EAEE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAAF;AACA,glDAAglD","sourcesContent":[".debug {\n  display: none;\n}\n\n.load {\n  display: block;\n  margin: 0 auto;\n}\n\nh2 {\n  margin: 0;\n  margin-left: 6px;\n  font-size: 14px;\n}\n\nh3 {\n  text-align: center;\n}\nh4 {\n  text-align: center;\n}\n\ntable {\n  width: 75%;\n  max-width: 900px;\n  margin: 0 auto;\n  font-family: consolas, monospace;\n  border-collapse: collapse;\n\n  thead th {\n    text-align: left;\n    width: 33.3%;\n  }\n\n  tbody tr {\n    border-top: 1px solid #eee;\n  }\n}\n\n/* (mdc-migration): The following rule targets internal classes of slider that may no longer apply for the MDC version. */\ninput[type=\"range\"],\nmat-slider {\n  width: 100%;\n  max-width: 600px;\n  display: block;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
